import store from '@/store'
import { getUserInfo, getLoginTime } from '@/utils/auth'
import { tdTracking } from '@/utils/index'
import {  getLocalStorage, setLocalStorage, removeLocalStorage } from "@/utils/storage";

export async function refreshToken() {
  const currentTime = new Date().getTime()
  const userInfo = getUserInfo()
  const loginTime = getLoginTime()
  if (loginTime && Object.keys(userInfo).length > 0) {
    const { tenant_id, expires_in, refresh_token, nick_name } = userInfo
    const splitTime = expires_in - (currentTime - loginTime) / 1000
    // if (splitTime < 300) { // token过期前5分钟获取新token
    if (splitTime < 60) { // token过期前1分钟获取新token
      let params = {
        tenantId: tenant_id,
        grantType: 'refresh_token',
        refresh_token: refresh_token,
        type: 'pwd'
      }
      const refreshTokenFlag = getLocalStorage('refreshTokenFlag')
      // 确保同一时间段内只执行一次
      if (!refreshTokenFlag) {
        setLocalStorage('refreshTokenFlag', 'true')
          var kv = {}
          var kv2 = {}
          kv[tenant_id] = 1
          kv2[`${tenant_id}_${nick_name}`] = 1
          tdTracking('tenant_login',  kv)
          tdTracking('account_login',  kv2)
        await store.dispatch('user/login', params).catch(function(err) {
          return ''
        })
        removeLocalStorage('refreshTokenFlag')
        return 'success'
      } else { // 正在获取token，不再重复请求
        return 'pending'
      }

    } else { // 未到过期时间，不请求
      return ''
    }
  }
}
